import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { Leistungen } from './pages/Leistungen';
import { Kieferorthopaedie } from './pages/Kieferorthopaedie';
import { Oralchirurgie } from './pages/Oralchirurgie';
import { TeamPage } from './pages/TeamPage';
import { Karriere } from './pages/Karriere';
import { BlogPage } from './pages/BlogPage';
import { Kontakt } from './pages/Kontakt';
export function App() {
  return <HashRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/leistungen" element={<Leistungen data-id="element-5" />} data-id="element-4" />
        <Route path="/kieferorthopaedie" element={<Kieferorthopaedie data-id="element-7" />} data-id="element-6" />
        <Route path="/oralchirurgie" element={<Oralchirurgie data-id="element-9" />} data-id="element-8" />
        <Route path="/team" element={<TeamPage data-id="element-11" />} data-id="element-10" />
        <Route path="/karriere" element={<Karriere data-id="element-13" />} data-id="element-12" />
        <Route path="/blog" element={<BlogPage data-id="element-15" />} data-id="element-14" />
        <Route path="/kontakt" element={<Kontakt data-id="element-17" />} data-id="element-16" />
      </Routes>
    </HashRouter>;
}